import { z } from 'zod'

export const executePlanResultItemSchema = z.object({
  instrumentUid: z.string(),
  ticker: z.string().nullable(),
  success: z.boolean(),
  wasRejected: z.boolean(),
  orderId: z.string().nullable(),
  error: z.string().nullable(),
  lotsRequested: z.number().int(),
  lotsExecuted: z.number().int(),
})

export type ExecutePlanResultItemDto = z.infer<typeof executePlanResultItemSchema>

export const executePlanResponseSchema = z.object({
  results: z.array(executePlanResultItemSchema),
  totalExecuted: z.number().int(),
  totalFailed: z.number().int(),
})

export type ExecutePlanResponseDto = z.infer<typeof executePlanResponseSchema>
